import { useQuery } from "react-query";
import { customerBusinessService } from "../services";
import {GUEST_USER} from "../constants";
import { getUser } from "../helpers/helperMethods";

const getProfileStatus = async (customerId: number) => {
    const response = await customerBusinessService.getUserProfileStatus(customerId)
    return response.data.data;
};

export default function useGetProfileStatus() {
    const user = getUser();

    return useQuery("userStatus", () => getProfileStatus(user?.id), {
        enabled: user?.hasOwnProperty('id') && user?.hasOwnProperty('type') && user?.type !== GUEST_USER
    });
}